/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalViewerCreateRequest } from '../models/ExternalViewerCreateRequest';
import type { ExternalViewerUpdateRequest } from '../models/ExternalViewerUpdateRequest';
import type { SuccessResponse_ExternalViewerAccountOut_ } from '../models/SuccessResponse_ExternalViewerAccountOut_';
import type { SuccessResponse_ExternalViewerBindingTokenResponse_ } from '../models/SuccessResponse_ExternalViewerBindingTokenResponse_';
import type { SuccessResponse_ExternalViewerCreateResponse_ } from '../models/SuccessResponse_ExternalViewerCreateResponse_';
import type { SuccessResponse_list_ExternalViewerAccountOut__ } from '../models/SuccessResponse_list_ExternalViewerAccountOut__';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExternalViewersService {
    /**
     * List External Viewers Endpoint
     * @returns SuccessResponse_list_ExternalViewerAccountOut__ Successful Response
     * @throws ApiError
     */
    public static listExternalViewersEndpointApiV1AdminExternalViewersGet(): CancelablePromise<SuccessResponse_list_ExternalViewerAccountOut__> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/external-viewers',
        });
    }
    /**
     * Create External Viewer Endpoint
     * @returns SuccessResponse_ExternalViewerCreateResponse_ Successful Response
     * @throws ApiError
     */
    public static createExternalViewerEndpointApiV1AdminExternalViewersPost({
        requestBody,
    }: {
        requestBody: ExternalViewerCreateRequest,
    }): CancelablePromise<SuccessResponse_ExternalViewerCreateResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/external-viewers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update External Viewer Endpoint
     * @returns SuccessResponse_ExternalViewerAccountOut_ Successful Response
     * @throws ApiError
     */
    public static updateExternalViewerEndpointApiV1AdminExternalViewersAccountIdPatch({
        accountId,
        requestBody,
    }: {
        accountId: number,
        requestBody: ExternalViewerUpdateRequest,
    }): CancelablePromise<SuccessResponse_ExternalViewerAccountOut_> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/admin/external-viewers/{account_id}',
            path: {
                'account_id': accountId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete External Viewer Endpoint
     * @returns SuccessResponse_ExternalViewerAccountOut_ Successful Response
     * @throws ApiError
     */
    public static deleteExternalViewerEndpointApiV1AdminExternalViewersAccountIdDelete({
        accountId,
    }: {
        accountId: number,
    }): CancelablePromise<SuccessResponse_ExternalViewerAccountOut_> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/admin/external-viewers/{account_id}',
            path: {
                'account_id': accountId,
            },
            errors: {
                403: `Only the registry-backed super-admin may manage test accounts.`,
                404: `The test account does not exist or has already been deleted.`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Regenerate External Viewer Binding Token Endpoint
     * @returns SuccessResponse_ExternalViewerBindingTokenResponse_ Successful Response
     * @throws ApiError
     */
    public static regenerateExternalViewerBindingTokenEndpointApiV1AdminExternalViewersAccountIdBindingTokenPost({
        accountId,
    }: {
        accountId: number,
    }): CancelablePromise<SuccessResponse_ExternalViewerBindingTokenResponse_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/external-viewers/{account_id}/binding-token',
            path: {
                'account_id': accountId,
            },
            errors: {
                403: `Only the registry-backed super-admin may manage test accounts.`,
                404: `The test account does not exist or has already been deleted.`,
                409: `The test account expired or its binding state changed.`,
                422: `Validation Error`,
            },
        });
    }
}
